export const linkedAdjustmentKeyBuilder = (
  documentCode,
  groupName,
  adjustmentNumber,
  adjustmentName
) => `${documentCode}_${groupName}_${adjustmentNumber}_${adjustmentName}`;

export const keyParser = (token = '') => {
  const items = token.split('_');
  if (items.length !== 4) {
    return '';
  }

  return {
    code: items[0],
    group: items[1],
    number: items[2],
    name: items[3],
  };
};
